import { render, staticRenderFns } from "./NsCheckbox.vue?vue&type=template&id=3bc52bd3&scoped=true&"
import script from "./NsCheckbox.vue?vue&type=script&lang=js&"
export * from "./NsCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./NsCheckbox.vue?vue&type=style&index=0&id=3bc52bd3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc52bd3",
  null
  
)

export default component.exports